import Customer from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

const initialConfigState = {
  modelId: null,
  type: 'account',
  value: ''
}

export default {
  namespaced: true,
  state: {
    customers: [],
    filteredCollection: [],
    current: new Customer(),
    currentConfig: initialConfigState
  },
  getters: {
    getCollection: state => state.customers,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.customers.find(customer => customer.id === id),
    getCurrent: state => state.current,
    getCurrentConfig: state => state.currentConfig
  },
  actions: {
    getCollection({ commit, getters, state }, payload) {
      return this.dispatch('get', {
        path: 'v1/customers?include=accounts,applicationServer',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((customer) => {
            commit('addCustomerToCollection', { customerData: customer })
            return getters.getById(customer.id)
          })

          commit('addCustomerToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    create({ commit, getters }, model) {
      return this.dispatch('post', {
        path: 'v1/customers?include=accounts',
        data: model.getJSON()
      }).then((res) => {

        commit('addCustomerToCollection', { customerData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    update({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/customers/' + model.id + '?include=accounts',
        data: model.getJSON()
      }).then((res) => {

        commit('addCustomerToCollection', { customerData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    delete({ commit }, data) {
      return this.dispatch('del', {
        path: 'v1/customers/' + data.id,
        data: {
          deleteMediaManagerCustomer: data.deleteMediaManagerCustomer
        }
      }).then((res) => {

        commit('removeCustomerFromCollection', data.id)

        return res
      })
    },
    getConfig ({ commit, dispatch }, payload) {
      return this.dispatch('get', {
        path: 'v1/configs/customer/' + payload.modelId
      }).then((config) => {
        if (config.message) {
          if (config.message === 'Could not find the resource.') {
            // create new config
            return dispatch('updateConfig', {
              modelId: payload.modelId,
              value: ''
            }).then(() => {
              return dispatch('getConfig', {
                modelId: payload.modelId
              }).then((res) => {
                return res
              })
            })
          }

          throw config.message

        } else {
          const data = deepGet(config, 'data.value')
          const commitData = data && (data.length > 0 || typeof data === 'object') ? data : initialConfigState.value
          commit('updateCurrentConfig', commitData)
          return config.data
        }
      })
    },
    updateConfig (store, payload) {
      return this.dispatch('post', {
        path: 'v1/configs',
        data: {
          type: 'customer',
          modelId: payload.modelId,
          value: payload.value
        }
      })
    }
  },
  mutations: {
    addCustomerToCollection(state, { customerData, opts }) {
      // special cleanup on applicationServer
      customerData.applicationServerName = deepGet(customerData, 'applicationServer.data.name')
      addToCollection(this, state.customers, customerData, Customer, opts)
    },
    addCustomerToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeCustomerFromCollection(state, customerId) {
      const index = state.customers.findIndex(el => el.id === customerId)

      if (index === -1) {
        console.warn(`Could not find/delete customer ${customerId}`)
        return
      }

      state.customers.splice(index, 1)
    },
    clearCollection(state) {
      state.customers = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    updateCurrent (state, customer) {
      state.current = customer
      if (
        customer.applicationServer &&
        customer.applicationServer.data &&
        customer.applicationServer.data.id) {
        // in if
        state.current.applicationServerId = customer.applicationServer.data.id
      }
    },
    resetCurrent(state) {
      state.current = new Customer()
    },
    updateCurrentConfig (state, data) {
      state.currentConfig.value = data
    },
    removeAccountFromCustomer(state, accountId) {
      state.customers.forEach((customer) => {
        const accountToRemove = customer.accounts.data.findIndex(account => account.id === accountId)

        if (accountToRemove > -1) {
          customer.accounts.data.splice(accountToRemove, 1)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/customer/store.js